package com.eladfinish.bible.contest.screens.search.ai.remote

interface OpenAiApiKeyProvider {
    fun getApiKey(): String
}

class OpenAiApiKeyProviderTemp : OpenAiApiKeyProvider {
    override fun getApiKey(): String {
        return "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"
    }
}
